import { BUSERS_ROUTES } from '../../constants/_routes'
import busersTypes from '../../constants/busersTypes'
import { axios } from '../../services'
import { current_timestamp } from '../../helpers'

// INDEX
const busers_index_request = () => {
  return {
    type: busersTypes.index.request
  }
}

const busers_index_success = (response) => {
  return {
    type: busersTypes.index.success,
    payload: response.data
  }
}

const busers_index_failure = (messages) => {
  return {
    type: busersTypes.index.failure,
    payload: messages
  }
}

const busers_index = (page=1, per_page=10, filters={}, sort="", order="") => {
  return function (dispatch) {
    // Before Request
    dispatch(busers_index_request())

    // Request
    axios.get(
      BUSERS_ROUTES.index,
      {
        params: {
          page: page,
          per_page: per_page,
          sort: sort,
          order: order,
          filters: filters,
          serial: current_timestamp()
        }
      }
    ).then( response => {
      // success
      dispatch( busers_index_success(response) )
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error fetching users."]
      }
      // dispatch( try_force_logoff(error.response.data) )
      dispatch( busers_index_failure(errors))
    })
  }

}

const busers_select_success = (response) => {
  return {
    type: busersTypes.index.select,
    payload: response.data
  }
}


const busers_select = () => {
  return function (dispatch) {
    // Before Request
    dispatch(busers_index_request())

    // Request
    axios.get(
      BUSERS_ROUTES.select
    ).then( response => {
      // success
      dispatch( busers_select_success(response) )
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error fetching users."]
      }
      dispatch( busers_index_failure(errors))
    })
  }
}

export {
  busers_index,
  busers_select
}



// WEBPACK FOOTER //
// ./src/js/actions/busers/getindex.js